import JassEnum from './enum';

/**
 * type playerstate
 */
export default class JassPlayerState extends JassEnum {}
